import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    margin: 10,
    minWidth: 150,
    width: "46vmin",
  },
  placeholder: {
    color: "$input_placeholder",
  },
  textBox: {
    zIndex: 10,
    borderWidth: 1,
    borderColor: "$input_background",
    backgroundColor: "$input_background",
  },
  correctBox: {
    borderColor: "$correct",
  },
  incorrectBox: {
    borderColor: "$incorrect",
  },
  text: {
    height: 120,
    padding: 10,
    color: "$input_text",
    textAlignVertical: "top",
    fontSize: "$openended_text_size",
    fontFamily: "$openended_text_style",
  },
  correctText: {
    color: "$correct",
  },
  incorrectText: {
    color: "$incorrect",
  },
  remainingView: {
    alignSelf: "flex-end",
  },
  remainingText: {
    fontSize: "$openended_remaining_text_size",
    fontFamily: "$openended_remaining_text_style",
    flexWrap: "wrap",
    color: "$help_text",
    margin: 10,
  },
});
